import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getArrayComparisonTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'remaining-destination',
			selector: '[data-tour="remaining-destination"]',
			content: 'Optional: Set the task that will execute with the remaining records set.',
		},
		{
			id: 'match-action',
			selector: '[data-tour="match-action"]',
			content:
				'Required: The logic that will be applied to the result after running the match logic. This works like Venn diagram logic. NB: "Combine Matching Indexes", does not allow for additional rule setting.',
		},
		{
			id: 'collection-a',
			selector: '[data-tour="collection-a"]',
			content:
				'Required: The first field containing a collection of data or the "Left Side" values.',
		},
		{
			id: 'collection-b',
			selector: '[data-tour="collection-b"]',
			content:
				'Required: The first field containing a collection of data or the "Right Side" values.',
		},
		{
			id: 'result-type',
			selector: '[data-tour="result-type"]',
			content: 'Required: The format of the result records in the output data tab. ',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
